var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M10.894 3.823A4.527 4.527 0 0 0 9.3 3.819a4.321 4.321 0 0 0-1.467.542c-.893.534-1.494 1.353-1.698 2.263a.625.625 0 0 1-.61.488c-.877 0-1.713.334-2.325.92a3.033 3.033 0 0 0-.95 2.19c0 .817.338 1.605.95 2.19.612.587 1.448.921 2.325.921a.625.625 0 0 1 0 1.25 4.614 4.614 0 0 1-3.19-1.267A4.283 4.283 0 0 1 1 10.223c0-1.166.484-2.278 1.335-3.093a4.597 4.597 0 0 1 2.71-1.243c.365-1.072 1.127-1.99 2.146-2.599a5.571 5.571 0 0 1 1.891-.7 5.777 5.777 0 0 1 2.036.005 5.565 5.565 0 0 1 1.887.711 5.07 5.07 0 0 1 1.458 1.324 4.6 4.6 0 0 1 .798 1.75c.082.378.114.762.096 1.144h.116A3.525 3.525 0 0 1 19 11.052a3.533 3.533 0 0 1-3.527 3.531h-.829a.625.625 0 1 1 0-1.25h.83a2.275 2.275 0 0 0 2.276-2.28 2.283 2.283 0 0 0-2.277-2.28h-.829a.625.625 0 0 1-.61-.762c.102-.451.103-.915.005-1.367a3.35 3.35 0 0 0-.582-1.275c-.287-.39-.66-.73-1.1-.996a4.316 4.316 0 0 0-1.463-.55Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M9.562 8.554a.625.625 0 0 1 .876 0l2.5 2.459a.625.625 0 0 1-.876.891L10 9.877l-2.062 2.027a.625.625 0 1 1-.876-.891l2.5-2.459Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M10 8.375c.345 0 .625.28.625.625v7.458a.625.625 0 1 1-1.25 0V9c0-.345.28-.625.625-.625Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadCloud);
export default __webpack_public_path__ + "static/media/upload_cloud.5c2d05f1f9655ac36f6a03fd55377947.svg";
export { ForwardRef as ReactComponent };